import { formatearMXN } from './formato'
import { tc } from './idioma'

type Props = {
  /** null: la empresa aún no está verificada y no puede ver precios. */
  importe: number | null
  ivaPorcentaje?: number
  /** Precio original en dólares cuando el importe en pesos es una conversión. */
  usd?: number
}

/** Importe tabular con código de moneda y tasa de IVA (DESIGN.md → Precio). */
export function Precio({ importe, ivaPorcentaje, usd }: Props) {
  if (importe === null) {
    return <span className="precio precio--oculto">{tc().precioOculto}</span>
  }
  return (
    <span className="precio">
      {formatearMXN(importe)}
      <span className="precio__moneda">MXN</span>
      {ivaPorcentaje !== undefined && (
        <span className="precio__iva">{ivaPorcentaje === 0 ? tc().iva0 : tc().masIva(ivaPorcentaje)}</span>
      )}
      {usd !== undefined && <span className="precio__usd">US$ {formatearMXN(usd)}</span>}
    </span>
  )
}
